import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Table, Popconfirm, message, LocaleProvider } from 'antd';
import ui from '../../lang/ui.json';
import s from './User.css';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../components/Breadcrumbs';
import {fetchDecode} from '../../fetchUtils';

class User extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      name: '',
      groups: [],
      config: require('Config'),
    };
  }

  componentDidMount() {
      fetchDecode(this.state.config.serverUrl + `contacts/user/${this.props.id}`, message)
        .then(response => this.setState({
        name: response.name,
        groups: response.groupmembership,
      }))
  };

  successMessage = () => {
    message.success(this.props.locale.messageSuccess, 2);
  };

  errorMessage = (error) => {
    message.error(`${this.props.locale.messageError} ${error}`, 5);
  };

  deleteFromTable = (row) => {
    const dataSource = this.state.groups;
    const index = dataSource.findIndex(data => data.id === row);
    dataSource.splice(index, 1);
    this.setState({ groups: dataSource });
  };

  deleteUserFromGroup = (id) => {
    fetch(this.state.config.serverUrl + `groups/deleteUser/${id}/${this.props.id}`,
      {
        headers: new Headers({
            'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
            'Content-Type': 'application/json',
            'username': `${sessionStorage.getItem('username')}`
        }),
        method: 'DELETE',
      },
    ).then((response) => {
      if (response.status === 204) {
        this.successMessage();
        this.deleteFromTable(id);
      } else {
        this.errorMessage(response.statusText);
      }
    });
  };

  render() {
    const columns = [{
      title: this.props.locale.tableName,
      dataIndex: 'groupname',
      key: 'groupname',
      sorter: (a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      },
      render: (text, group) => <Link to={`/groups/${group.id}`}>{text}</Link>,
    }, {
      title: this.props.locale.tableMembers,
      dataIndex: 'members',
      key: 'members',
      sorter: (a, b) => {
        if (a.members < b.members) return -1;
        if (a.members > b.members) return 1;
        return 0;
      },
    }, {
      title: '',
      key: 'id',
      dataIndex: 'id',
      width: 30,
      render: id => (
        <Popconfirm
          title={this.props.locale.confirm}
          onConfirm={() => this.deleteUserFromGroup(id)}
        >
          <Icon type="close-circle-o" className={s.delete} />
        </Popconfirm>
      ),
    }];
    return (
      <LocaleProvider locale={ui}>
        <div className={s.root}>
          <Breadcrumbs title={this.props.locale.breadcrumbs} link="/contacts" />
          <div className={s.header}>
            <div className={s.headline}>
              <h1>{this.state.name}</h1>
              <div className={s.headline_cont}>
                <Link to={`${this.props.id}/rename_user`} className={s.headline__btn}>
                  <Icon className={s.headline__icon} type="edit" />
                  {this.props.locale.button}
                </Link>
              </div>
            </div>
            <div className={s.subtitle} style={{visibility: this.state.name !== this.props.id ? "visible" : "hidden"}}>
              <h2>{this.props.id}</h2>
            </div>
          </div>
          <label className={s.input_wrapper} htmlFor="table">
            <span className={s.input_name}>{this.props.locale.tableHeadline}</span>
            <Table
              className={s.table}
              columns={columns}
              dataSource={this.state.groups}
              rowKey={r => r.groupname}
            />
          </label>
        </div>
      </LocaleProvider>
    );
  }
}

export default (User);




// WEBPACK FOOTER //
// ./src/routes/contacts/User.js